<template>
  <div class="intro-screen">
    <div class="intro-title">Escape from school</div>
    <div class="intro-text">Help Milton finish school so that he can go to scout camp!</div>
    <div style="margin-top: 5vh">
      <button class="start-button" v-on:click="onClickStartGame">Start Game</button>
      <button class="start-button" v-on:click="onClickTutorial">Watch Tutorial</button>
    </div>

    <div class="orientation-warning">
      Please turn your device!
    </div>
  </div>

</template>

<script>

import { mapState } from "vuex";

export default {
  name: "IntroScreen",
  data() {
    return {
      currentTime: 0,
      timerRunning: false,
    };
  },
  computed: {
    ...mapState(["gameState"])
  },
  methods: {
    onClickStartGame: function() {
      console.log("onClickStartGame, ");
      this.$store.dispatch("changeGameState", { name: "Game" });
      this.$store.commit("startWeek");
    },
    onClickTutorial: function() {
      console.log("onClickStartGame, ");
      this.$store.dispatch("changeGameState", { name: "Tutorial" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.intro-screen {
  background: #562b53;
  background-image: url('../assets/Intro.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  color: white;
  width: 100vw;
  height: 100vh;
  text-align: center;

  .intro-title {
    font-size: 10vw;
  }

  .intro-text {
    margin-left: 10vw;
    margin-right: 10vw;
    font-size: 3vw;
  }

  .start-button {
    background-color: #fff4df;
    border: none;
    color: black;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 4vw;
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 20px;
  }
}

@media (orientation: portrait) {
  .orientation-warning {
    margin-top: 5vh;
    font-size: 1.6em;
  }
}

@media (orientation: landscape) {
  .orientation-warning {
    display: none;
  }
}


</style>
